module.exports = __webpack_public_path__ + "static/media/Image03.27a06bfb.png";